import Axios, { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';

export function cancellableRequest<T>(
  modifyRequest: (token: CancelToken) => T & any,
  cancellable: () => boolean = () => true
) {
  const source = Axios.CancelToken.source();
  const request = modifyRequest(source.token);
  request[CANCEL] = () => {
    if (cancellable()) {
      source.cancel();
    }
  };
  return request;
}
